import React from 'react';
import { Navbar } from '../components/layouts/Navbar';
import { PlannerSidebar } from '../components/layouts/PlannerSidebar';
import { NewImportForm } from '../components/import/NewImportForm';

const Importacoes: React.FC = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F4EFFA' }}>
      <Navbar />
      <div className="flex p-6 gap-3">
        <div className="flex-1">
          <h1 className="text-2xl font-semibold mb-2" style={{ color: '#3d2b56' }}>Importações</h1>
          <p className="text-xs mb-6" style={{ color: '#9E9E9E' }}>Faça upload de arquivos para importar dados. Use os formulários abaixo.</p>

            {/* Intencionalmente sem cards de resumo — esta página foca apenas em importações */}

            <section className="space-y-3">
              {/* Reuse ImportForm if available; if ImportForm is a default export adapt accordingly */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <NewImportForm 
                  type="cliente" 
                  title="Lista de Clientes" 
                  description="Importar dados do relatório RptClienteLista.XLS" 
                />
                <NewImportForm 
                  type="analise" 
                  title="Análise de Produção" 
                  description="Importar dados do RptAnaliseProducao.XLS (cria parcelas automaticamente)" 
                />
                <NewImportForm 
                  type="multcalculo" 
                  title="Cálculos Multi" 
                  description="Importar dados do RptMultCalculo.XLSX" 
                />
                <NewImportForm 
                  type="propostas" 
                  title="Propostas Pendentes" 
                  description="Importar propostas pendentes do RptPropostaPend.XLS" 
                />
                <NewImportForm 
                  type="migracao" 
                  title="Migração CSV" 
                  description="Importar dados de migração do arquivo CSV" 
                />
              </div>
          </section>
        </div>
        <div className="hidden lg:block">
          <PlannerSidebar />
        </div>
      </div>
    </div>
  );
};

export default Importacoes;
